import * as Accordion from "@radix-ui/react-accordion"
import { PlusIcon } from "@radix-ui/react-icons"
import parse from "html-react-parser"
import { FAQPageJsonLd } from "next-seo"
import { stripHtmlSpaces } from "../../utils/strip-html-spaces"
import { stripHtml } from "../../utils/stripHtml"
import { DynamicHeadline } from "../DynamicHeadline"
import Section, { parseColors } from "../Section"
import styles from "./Accordion.module.scss"

const AccordionComponent = ({ data = {}, colors }) => {
  const {
    accordion,
    dynamic_headline: dynamicHeadline,
    headline_type: headlineType,
    headline_appearance: headlineAppearance,
    ankerslug,
  } = data

  const { accent } = parseColors({ colors })

  return (
    <Section
      sectionSpacing={{
        top: data?.section_padding_top?.value || null,
        bottom: data?.section_padding_bottom?.value || null,
      }}
      id={ankerslug}
      className={styles.section}
      style={{ "--open-color": accent.color }}
      colors={colors}
    >
      <FAQPageJsonLd
        keyOverride={"accordion+" + Math.floor(Math.random() * 100000)}
        mainEntity={accordion.map((a) => ({
          questionName: a.dynamic_headline,
          acceptedAnswerText: stripHtml(a.accordionitem_content),
        }))}
      />

      <DynamicHeadline
        className={styles.headline}
        headlineType={headlineType.value}
        headlineAppearance={headlineAppearance.value}
      >
        {dynamicHeadline}
      </DynamicHeadline>

      <div className={styles.wrapper}>
        <Accordion.Root type="single" collapsible>
          {accordion.map((item, i) => {
            return (
              <Accordion.Item
                key={i}
                value={`item-${i + 1}`}
                className={styles.accordionItem}
              >
                <Accordion.Header asChild>
                  <Accordion.Trigger>
                    <div className={styles.itemHeadline}>
                      <div className={styles.icon}>
                        <PlusIcon aria-hidden />
                      </div>
                      <DynamicHeadline
                        headlineType={"h3"}
                        headlineAppearance={"h4"}
                      >
                        {item.dynamic_headline}
                      </DynamicHeadline>
                    </div>
                  </Accordion.Trigger>
                </Accordion.Header>
                <Accordion.Content className={styles.content}>
                  <div className={styles.innerContent}>
                    {item.accordionitem_content &&
                      parse(stripHtmlSpaces(item.accordionitem_content))}
                  </div>
                </Accordion.Content>
              </Accordion.Item>
            )
          })}
        </Accordion.Root>
      </div>
    </Section>
  )
}

export default AccordionComponent
